import {h, Fragment} from "preact"
import { activateSearchPage } from '../../helpers'

export default function SubmitButton({ className, text }) {
    return (
        <div className={`ns-autocomplete-submit ns-d-flex ns-justify-content-left ${className}`}>
            <button 
                type="submit" 
                className="ns-text-align-left ns-w-100 hyperLink"
                onClick={() => {
                    window.scrollTo(0, 0);
                    activateSearchPage();
                }}
            >
                {text}
            </button>
        </div>
    )
}